export default {
  model (resource) {
    return Object.assign({
      name: '',
      description: '',
      type: '',
      startDate: null,
      endDate: null,
      status: 'pending'
    }, resource)
  },
  rules () {
    return {
      name: [
        {required: true, message: 'El nombre de la campaña es requerido'},
        {min: 1, max: 255, message: 'El nombre debe contener entre 1 y 255 caracteres'}
      ],
      description: [
        {required: true, message: 'La descripción de la campaña es requerido'},
        {min: 1, max: 255, message: 'La descripción debe contener entre 1 y 255 caracteres'}
      ],
      type: [
        {required: true, message: 'El tipo de campaña es requerido'}
      ],
      startDate: [
        {required: true, message: 'La fecha de inicio de la campaña es requerida'}
      ],
      endDate: [
        {required: true, message: 'La fecha de fin de la campaña es requerida'}
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/campaigns/campaign-model.js